/**
 * Destaque dos campos preenchidos automaticamente (DataJud, CNPJ, CEP):
 * fundo verde-claro + pulso ao chegar; some quando a pessoa edita o campo.
 *   const af = useAutofill();
 *   af.mark(["organName", "instance"]);            // depois da busca
 *   <input className={af.cls("organName")} data-af="organName" …/>
 *   <div onInputCapture={af.onInput}>…</div>       // no container do formulário
 */
import { useState } from "react";

export function useAutofill() {
  const [keys, setKeys] = useState<Set<string>>(new Set());
  const [labels, setLabels] = useState<string[]>([]);
  // Campos que a busca NÃO preencheu e que precisam ser completados (amarelo).
  const [need, setNeed] = useState<Map<string, string>>(new Map());
  const drop = (k: string) => {
    if (keys.has(k)) setKeys((cur) => { const n = new Set(cur); n.delete(k); return n; });
    if (need.has(k)) setNeed((cur) => { const n = new Map(cur); n.delete(k); return n; });
  };
  return {
    mark: (ks: string[], names?: string[]) => { setKeys((cur) => new Set([...cur, ...ks])); if (names) setLabels(names); },
    /** Marca em amarelo os campos a completar: [chave, rótulo]. */
    needs: (items: Array<[string, string]>) => setNeed(new Map(items)),
    has: (k: string) => keys.has(k),
    cls: (k: string, base = "input") => `${base}${keys.has(k) ? " autofilled" : need.has(k) ? " needsfill" : ""}`,
    /** Para componentes sem className (selects próprios): envolve com a marcação. */
    wrap: (k: string) => (keys.has(k) ? "af-wrap autofilled" : need.has(k) ? "af-wrap needsfill" : undefined),
    done: drop,
    onInput: (e: React.SyntheticEvent) => {
      const k = (e.target as HTMLElement).closest?.("[data-af]")?.getAttribute("data-af") ?? (e.target as HTMLElement).dataset?.af;
      if (k) drop(k);
    },
    count: keys.size,
    /** Aviso "Preenchido automaticamente: …" + "Complete: …" */
    summary: (source: string) => (keys.size || need.size ? (
      <>
        {keys.size > 0 && labels.length > 0 && <div className="autofill-note">✓ Preenchido automaticamente pelo {source}: <strong>{labels.join(", ")}</strong>. Os campos em verde vieram da busca — confira.</div>}
        {need.size > 0 && <div className="needsfill-note">Complete os campos em amarelo: <strong>{[...need.values()].join(", ")}</strong>.</div>}
      </>
    ) : null),
    clear: () => { setKeys(new Set()); setLabels([]); setNeed(new Map()); },
  };
}
